// extracted by mini-css-extract-plugin
export default {"row":"auth__row__FfPZfw","startAligned":"auth__startAligned__Ch1UrQ","endAligned":"auth__endAligned__VQYpG3","border":"auth__border__HZ1J3S"};